export enum NewsRecapSectionType {
  Research = 'research',
  PcwAdditions = 'pcwAdditions',
  IPOsScheduled = 'scheduled',
  AnalystNotes = 'analystNotes',
  UsExternalNews = 'usExternalNews',
  NonUsExternalNews = 'nonUsExternalNews',
}
